import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000/api';

// Get user profile
export const fetchUserProfile = createAsyncThunk('profile/fetchProfile', async (token) => {
  const res = await axios.get(`/auth/profile`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    withCredentials: true
  });
  return res.data;
});

// Update user profile
export const updateUserProfile = createAsyncThunk('profile/updateProfile', async ({ token, profileData }) => {
  const res = await axios.put(`/auth/profile`, profileData, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    withCredentials: true
  });
  return res.data;
});

// Change password
export const changePassword = createAsyncThunk('profile/changePassword', async ({ token, passwordData }) => {
  const res = await axios.put(`/auth/change-password`, passwordData, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    withCredentials: true
  });
  return res.data;
});

const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    user: null,
    status: 'idle',
    error: null
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch profile
      .addCase(fetchUserProfile.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload.user || action.payload;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      // Update profile
      .addCase(updateUserProfile.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload.user || action.payload;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      // Change password
      .addCase(changePassword.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export const { clearError } = profileSlice.actions;
export default profileSlice.reducer;
